import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AuthUser from './AuthUser';
import toast, { Toaster } from 'react-hot-toast';

export default function EditAgentStudent() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { http, user } = AuthUser();
    const [users, setUsers] = useState([]);
    const [classes, setClasses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [studentFiles, setStudentFiles] = useState({
        file_1: null,
        file_2: null,
        file_3: null,
        file_4: null,
        file_5: null
    });
    
    const [formData, setFormData] = useState({
        user_id: '',
        company_id: user.company_id,
        student_name: '',
        class: '',
        mobile_number: '',
        email_address: '',
        father_name: '',
        status: 0,
        hold_remark: ''
    });

    useEffect(() => {
        fetchUsers();
        fetchClasses();
        fetchStudentData();
    }, [id]);

    const fetchStudentData = () => {
        setIsDataLoading(true);
        http.get(`/agent_students?company_id=${user.company_id}`)
            .then((res) => {
                if (res.data.success && Array.isArray(res.data.data)) {
                    const student = res.data.data.find(s => s.id === parseInt(id));
                    if (student) {
                        setFormData({
                            user_id: student.user_id,
                            company_id: student.company_id,
                            student_name: student.student_name,
                            class: student.class || '',
                            mobile_number: student.mobile_number || '',
                            email_address: student.email_address || '',
                            father_name: student.father_name || '',
                            status: student.status || 0,
                            hold_remark: student.hold_remark || ''
                        });
                        // Store file information
                        setStudentFiles({
                            file_1: student.file_1,
                            file_2: student.file_2,
                            file_3: student.file_3,
                            file_4: student.file_4,
                            file_5: student.file_5
                        });
                    } else {
                        toast.error("Student not found");
                        navigate('/agent_student_list');
                    }
                } else {
                    console.error("API response is not as expected:", res.data);
                    toast.error("Failed to load student data");
                }
                setIsDataLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching student data:", error);
                toast.error("Error loading student data");
                setIsDataLoading(false);
                navigate('/agent_student_list');
            });
    };

    const fetchUsers = () => {
        http.get(`/users_by_company_department?company_id=${user.company_id}&department_id=4`)
            .then((res) => {
                if (res.data.success && Array.isArray(res.data.users)) {
                    setUsers(res.data.users);
                } else {
                    console.error("API response for users is not as expected:", res.data);
                    toast.error("Failed to load users");
                }
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
                toast.error("Error loading users");
            });
    };
    
    const fetchClasses = () => {
        http.get(`/class?company_id=${user.company_id}`)
            .then((res) => {
                if (Array.isArray(res.data.data)) {
                    setClasses(res.data.data);
                } else {
                    console.error("API response for classes is not an array");
                    toast.error("Failed to load classes");
                }
            })
            .catch((error) => {
                console.error("Error fetching classes:", error);
                toast.error("Error loading classes");
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await http.put(`/agent_student_update/${id}`, formData);
            
            if (response.data.success) {
                toast.success("Student updated successfully!");
                navigate('/agent_student_list');
            } else {
                toast.error(response.data.message || "Failed to update student");
            }
        } catch (error) {
            console.error("Error updating student:", error);
            toast.error(error.response?.data?.message || "An error occurred while updating the student");
        } finally {
            setIsLoading(false);
        }
    };

    const downloadFile = async (filename, fileLabel) => {
        if (!filename) {
            toast.error(`No file available for ${fileLabel}`);
            return;
        }
        
        try {
            // Use the http instance to get the file with proper authorization
            const response = await http.get(`/agent_student_download_file/${filename}`, {
                responseType: 'blob'
            });
            
            // Create a blob URL and trigger download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading file:", error);
            toast.error("Failed to download file");
        }
    };

    if (isDataLoading) {
        return (
            <div className="container mt-5">
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading student data...</p>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="container mt-5">
                <Toaster />
                <h3>Edit Conslt Student</h3>
                <form onSubmit={handleSubmit}>
                    {/* <div className="form-group mt-3">
                        <label>Select Agent <span className="text-danger">*</span></label>
                        <select 
                            id="user_id"
                            name="user_id"
                            className="form-control"
                            value={formData.user_id}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select an agent</option>
                            {users.map(user => (
                                <option key={user.id} value={user.id}>
                                    {user.name} {user.last_name || ''} ({user.email})
                                </option>
                            ))}
                        </select>
                    </div> */}

                    <div className="form-group mt-3">
                        <label>Student Name <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            id="student_name"
                            name="student_name"
                            className="form-control"
                            value={formData.student_name}
                            onChange={handleChange}
                            required
                            placeholder="Enter student name"
                        />
                    </div>

                    <div className="form-group mt-3">
                        <label>Class</label>
                        <select
                            id="class"
                            name="class"
                            className="form-control"
                            value={formData.class}
                            onChange={handleChange}
                        >
                            <option value="">Select a class</option>
                            {classes.map((classItem) => (
                                <option key={classItem.id} value={classItem.class_name}>
                                    {classItem.class_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group mt-3">
                        <label>Mobile Number</label>
                        <input
                            type="text"
                            id="mobile_number"
                            name="mobile_number"
                            className="form-control"
                            value={formData.mobile_number}
                            onChange={handleChange}
                            placeholder="Enter mobile number"
                        />
                    </div>

                    <div className="form-group mt-3">
                        <label>Email Address</label>
                        <input
                            type="email"
                            id="email_address"
                            name="email_address"
                            className="form-control"
                            value={formData.email_address}
                            onChange={handleChange}
                            placeholder="Enter email address"
                        />
                    </div>

                    <div className="form-group mt-3">
                        <label>Father's Name</label>
                        <input
                            type="text"
                            id="father_name"
                            name="father_name"
                            className="form-control"
                            value={formData.father_name}
                            onChange={handleChange}
                            placeholder="Enter father's name"
                        />
                    </div>
                    
                    <div className="form-group mt-3">
                        <label>Status</label>
                        <select
                            id="status"
                            name="status"
                            className="form-control"
                            value={formData.status}
                            onChange={handleChange}
                        >
                            <option value="0">Not Approved</option>
                            <option value="1">Approved</option>
                            <option value="2">Cancelled</option>
                            <option value="3">Hold</option>
                        </select>
                    </div>

                    {/* Show Hold Remark only when status is Hold (3) */}
                    {String(formData.status) === '3' && (
                        <div className="form-group mt-3">
                            <label>Hold Remark <span className="text-danger">*</span></label>
                            <textarea
                                id="hold_remark"
                                name="hold_remark"
                                className="form-control"
                                value={formData.hold_remark}
                                onChange={handleChange}
                                rows="3"
                                placeholder="Enter reason for holding this student..."
                                required
                            />
                            <small className="text-muted">Please provide a reason for putting this student on hold.</small>
                        </div>
                    )}

                    <div className="mt-4">
                        <button 
                            type="submit" 
                            className="btn btn-success me-2"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Updating...' : 'Update Student'}
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-secondary" 
                            onClick={() => navigate('/agent_student_list')}
                        >
                            Cancel
                        </button>
                    </div>
                </form>

                {/* Files Display Section */}
                <div className="mt-5">
                    <h4>Uploaded Files</h4>
                    <div className="row mt-3">
                        {['file_1', 'file_2', 'file_3', 'file_4', 'file_5'].map((fileKey, index) => (
                            <div key={fileKey} className="col-md-6 mb-3">
                                <div className="card">
                                    <div className="card-body">
                                        <h6 className="card-title">File {index + 1}</h6>
                                        {studentFiles[fileKey] ? (
                                            <div>
                                                <p className="card-text text-muted small mb-2">
                                                    {studentFiles[fileKey]}
                                                </p>
                                                <button
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => downloadFile(studentFiles[fileKey], `File ${index + 1}`)}
                                                >
                                                    <i className="fas fa-download me-1"></i>
                                                    Download
                                                </button>
                                            </div>
                                        ) : (
                                            <p className="card-text text-muted">No file uploaded</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}
